const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.685,18.048c-0.31,-0.304 -0.728,-0.475 -1.162,-0.475c-0.91,0 -1.659,0.749 -1.659,1.659c0,0.435 0.17,0.852 0.475,1.162l0.486,0.487l-0.972,0c-3.71,0 -5.762,-2.218 -7.874,-4.978c2.112,-2.76 4.164,-4.977 7.874,-4.977l0.972,0l-0.486,0.486c-0.316,0.312 -0.493,0.737 -0.493,1.181c0,0.91 0.748,1.658 1.659,1.658c0.443,0 0.868,-0.177 1.18,-0.493l3.318,-3.318c0.311,-0.311 0.486,-0.733 0.486,-1.173c0,-0.44 -0.175,-0.862 -0.486,-1.173l-3.318,-3.318c-0.31,-0.307 -0.729,-0.479 -1.166,-0.479c-0.91,0 -1.659,0.749 -1.659,1.659c0,0.436 0.173,0.855 0.479,1.166l0.486,0.486l-0.972,0c-4.842,0 -7.661,2.7 -9.955,5.581c-2.293,-2.881 -5.112,-5.581 -9.954,-5.581c-0.91,0 -1.659,0.749 -1.659,1.659c0,0.91 0.749,1.659 1.659,1.659c3.709,0 5.762,2.217 7.874,4.977c-2.112,2.76 -4.165,4.978 -7.874,4.978c-0.91,0 -1.659,0.748 -1.659,1.659c0,0.91 0.749,1.659 1.659,1.659c4.842,0 7.661,-2.701 9.954,-5.581c2.294,2.88 5.113,5.581 9.955,5.581l0.972,0l-0.486,0.486c-0.316,0.311 -0.493,0.737 -0.493,1.18c0,0.91 0.748,1.659 1.659,1.659c0.443,0 0.868,-0.178 1.18,-0.493l3.318,-3.318c0.311,-0.311 0.486,-0.734 0.486,-1.173c0,-0.44 -0.175,-0.863 -0.486,-1.173l-3.318,-3.319Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.88ace166848a1678d8e9302e34df52f1.svg";
export { ForwardRef as ReactComponent };